import { getRequest, putRequest } from '../utils/provider';
import { ApiResponse } from '../utils/responseTransform';

export async function getSettings(): Promise<
  ApiResponse<{ accountFeatures: UserFeatures; enterprise: AccountInfo; notifications: NotificationInfo }>
> {
  return getRequest('account_settings');
}

export async function updateSettings(payload): Promise<ApiResponse> {
  return putRequest('account_settings/update', payload);
}
